import { processCaptions } from 'utils/utils';
import { getGA } from 'analytics/GoogleAnalytics';

export default class OnboardingController {
  constructor(game, id, data, levelRef) {
    this.game = game;
    this.id = id;
    this.data = data;
    this.levelRef = levelRef; // reference to level - to get access to location/seeker/hud

    this.onEnd = new Phaser.Signal();

    this.captionsData = this.game.cache.getJSON(id + '_captions');
    if (this.captionsData) {
      this.captionsData = processCaptions(this.game, this.captionsData, this.id + '_vo-audioatlas');
      this.game.springRollCaptionsPlugin.setData(this.captionsData);
    }

    //
    this.skip = false;
    if (this.data.displayOnce) {
      this.skip = this.game.controller.player.wasOnboardingDisplayed(this.id);
    }
  }

  // processCaptions(audioName) {
  //   const vosData = this.game.cache.getJSON(audioName);

  //   for (const key in vosData.spritemap) {
  //     if (vosData.spritemap.hasOwnProperty(key)) {
  //       const cptItem = this.captionsData[key];
  //       if (!cptItem) {
  //         console.log("can't find: " + key);
  //       } else {
  //         const cpt = cptItem[0];
  //         const vo = vosData.spritemap[key];
  //         cpt.start = 0;
  //         if (vo) {
  //           cpt.end = (vo.end - vo.start) * 1000 + 100;
  //         } else {
  //           cpt.end = 1000; // 0;
  //         }
  //       }
  //     }
  //   }
  // }

  start() {
    this.ind = -1;
    this.time = 0;
    this.waitTime = 0;
    this.isDelayed = false;
    this.delayEvent = null;
    this.finished = false;

    this.nextEvent();
  }

  nextEvent() {
    this.ind++;
    this.time = 0;
    if (this.ind < this.data.events.length && !this.skip) {
      this.event = this.data.events[this.ind];
      this.waitTime = this.event.duration || 0;

      this.setEventEndCondition();

      // delay
      if (this.event.delay > 0) {
        this.isDelayed = true;
        this.delayEvent = this.game.time.events.add(this.event.delay * 1000, this.startEvent, this);
      } else {
        this.startEvent();
      }
    } else if (!this.finished) {
      // finish boarding
      this.finished = true;

      this.game.controller.player.saveOnboarding(this.id);

      // track
      if (this.data.tracking) {
        getGA().track({ action: 'TutorialComplete', label: this.data.tracking });
      }

      //
      this.onEnd.dispatch();
    }
  }

  /* eslint-disable max-statements */
  startEvent() {
    // console.log(this.event.action);
    this.isDelayed = false;
    this.delayEvent = null;
    // start action
    switch (this.event.action.type) {
      case 'lock_controls':
        this.levelRef.location.disableControls();
        this.levelRef.location.lockCharacters();
        break;
      case 'unlock_controls':
        this.levelRef.location.unlockCharacters();
        if (!this.event.action.onlyCharacters) {
          this.levelRef.location.enableControls();
        }
        break;
      case 'lock_hud':
        this.levelRef.gameHud.charactersList.lock();
        break;
      case 'unlock_hud':
        this.levelRef.gameHud.charactersList.unlock();
        break;
      case 'lock_arrows':
        this.levelRef.gameHud.lockArrows();
        break;
      case 'unlock_arrows':
        this.levelRef.gameHud.unlockArrows();
        break;
      case 'ui_unlock_icon': {
        const character = this.event.action.character;
        const hudSlotRef = this.levelRef.gameHud.charactersList.getSlotForCharacter(character);
        hudSlotRef.unlock();
        break;
      }
      case 'seeker_goto':
        if (this.event.action.from) {
          this.levelRef.seeker.setPosition(this.event.action.from);
        }
        this.levelRef.seeker.gotoPosition(this.event.action.to);
        break;
      case 'seeker_play_anim':
        this.levelRef.seeker.playAnim(this.event.action.name);
        break;
      case 'simple_character_add':
        this.levelRef.location.addSimpleCharacter(
          this.event.action.character_id,
          this.event.action.x,
          this.event.action.dir
        );
        break;
      case 'simple_character_remove':
        this.levelRef.location.removeSimpleCharacter(this.event.action.character_id);
        break;
      case 'simple_character_goto':
        this.levelRef.location.moveSimpleCharacter(
          this.event.action.character_id,
          this.event.action.x,
          this.event.action.time
        );
        break;
      case 'reveal_character': {
        const target = this.event.action.character;
        const slot = this.levelRef.location.findSlotWithCharacter(target);
        if (slot) {
          slot.character.findMe();
        }
        break;
      }
      case 'hide_character': {
        const character = this.event.action.character;
        const slot = this.levelRef.location.getSlotById(this.event.action.slot_id);
        const hudSlotRef = this.levelRef.gameHud.charactersList.getSlotForCharacter(character);
        hudSlotRef.setStateHidden();
        slot.addCharacter(character, hudSlotRef);
        slot.hudSlotRef = hudSlotRef;
        slot.character.removeControls();
        // this.levelRef.toPlace--;
        break;
      }
      case 'lock_character': {
        const target = this.event.action.character;
        const slot = this.levelRef.location.findSlotWithCharacter(target);
        if (slot) {
          slot.character.lock(this.event.action.withClothing);
        }
        break;
      }
      case 'unlock_character': {
        const target = this.event.action.character;
        const slot = this.levelRef.location.findSlotWithCharacter(target);
        if (slot) {
          slot.character.unlock();
        }
        break;
      }
      case 'play_vo': {
        let textId = this.event.action.textId;

        if (this.event.action.alts) {
          const ind = Math.floor(Math.random() * this.event.action.alts.length);
          textId += this.event.action.alts[ind];
        }

        if (this.event.action.suffix) {
          if (this.game.device.desktop) {
            textId += this.event.action.suffix.desktop;
          } else {
            textId += this.event.action.suffix.mobile;
          }
        }

        this.game.springRollCaptionsPlugin.playCaption(textId);
        this.playingVO = this.game.sounds.playVO(textId, { spriteID: this.id + '_vo' });
        // set wait time from captions data
        const data = this.captionsData[textId];
        this.waitTime = this.waitTime > 0 ? this.waitTime : data[data.length - 1].end / 1000;
        if (this.event.action.withAnim) {
          this.levelRef.seeker.startTalkForward(this.waitTime * 0.9 * 1000);
        }
        break;
      }
      case 'stop_last_vo':
        if (this.playingVO) {
          this.playingVO.stop();
          this.playingVO = null;
          if (this.levelRef.seeker) {
            this.levelRef.seeker.stopTalkForward();
          }
        }
        break;
      case 'set_toPlace':
        this.levelRef.toPlace = this.event.action.value;
        // if character is dragged increase number on chracters to place
        if (this.levelRef.location.isDraggingCharacter) {
          this.levelRef.toPlace++;
        }
        break;
      case 'ui_enlarge_character_icon':
        this.levelRef.gameHud.charactersList.enlargeCharacter(this.event.action.character);
        break;
      case 'ui_normalize_character_icon':
        this.levelRef.gameHud.charactersList.normalizeCharacter(this.event.action.character);
        break;
      case 'ui_pulse_character_icon':
        this.levelRef.gameHud.charactersList.pulseCharacter(
          this.event.action.character,
          this.event.action.repeat || -1
        );
        break;
      case 'camera_pan':
        this.levelRef.camera.pan(this.event.action.x);
        break;
      case 'ui_show_goto_marker':
        this.levelRef.location.addGotoMarker(this.event.action.x);
        break;
      case 'ui_show_scroll_arrow':
        this.levelRef.gameHud.showScrollArrow(this.event.action.arrow, this.event.action.enabled);
        break;
      case 'ui_hide_scroll_arrow':
        this.levelRef.gameHud.hideScrollArrow(this.event.action.arrow, this.event.action.enabled);
        break;
      case 'ui_set_scroll_arrow_state':
        this.levelRef.gameHud.setScrollArrowState(this.event.action.arrow, this.event.action.state);
        break;
      case 'ui_show_check_mark':
        this.levelRef.displayContinueButton();
        break;
      case 'ui_show_slot_marker':
        this.levelRef.location.showSlotMarker(this.event.action.slot_id);
        break;
      case 'ui_hide_slot_marker':
        this.levelRef.location.hideSlotMarker(this.event.action.slot_id);
        break;
      case 'ui_disable_all_slots':
        this.levelRef.location.disableAllSlots();
        break;
      case 'ui_enable_slot':
        this.levelRef.location.enableSlot(this.event.action.slot_id);
        break;
      case 'ui_disable_slot':
        this.levelRef.location.disableSlot(this.event.action.slot_id);
        break;
      case 'ui_pulse_clothing_button': {
        const target = this.event.action.character;
        const slot = this.levelRef.location.findSlotWithCharacter(target);
        slot.character.btnClothingEdit.pulse(4);
        break;
      }
      case 'ui_hide_clothing_check': {
        const target = this.event.action.character;
        const slot = this.levelRef.location.findSlotWithCharacter(target);
        slot.character.btnClothingCheck.visible = false;
        break;
      }
      case 'ui_show_clothing_check': {
        const target = this.event.action.character;
        const slot = this.levelRef.location.findSlotWithCharacter(target);
        slot.character.btnClothingCheck.visible = true;
        break;
      }
      case 'ui_hide_clothing_edit': {
        const target = this.event.action.character;
        const slot = this.levelRef.location.findSlotWithCharacter(target);
        slot.character.btnClothingEdit.visible = false;
        break;
      }
      case 'ui_show_clothing_edit': {
        const target = this.event.action.character;
        const slot = this.levelRef.location.findSlotWithCharacter(target);
        slot.character.btnClothingEdit.visible = true;
        break;
      }
      case 'ui_pulse_clothes':
        this.levelRef.gameHud.clothesList.pulseItems();
        break;
      case 'ui_stop_pulse_clothes':
        this.levelRef.gameHud.clothesList.stopPulseItems();
        break;
      case 'ui_show_draghand':
        this.levelRef.gameHud.charactersList.showDragHand(this.event.action.character);
        break;
      case 'ui_hide_draghand':
        this.levelRef.gameHud.charactersList.hideDragHand(this.event.action.character);
        break;
      case 'ui_hide_character_arrow':
        this.levelRef.gameHud.charactersList.hideArrow(this.event.action.character);
        break;
      case 'ui_show_character_arrow':
        this.levelRef.gameHud.charactersList.showArrow(this.event.action.character);
        break;
    }

    // set next event id - used for looped events
    if (this.event.next_event_id !== undefined) {
      this.ind = this.event.next_event_id - 1;
    }

    // directly go to next event if possible
    if (this.waitTime === 0 && (!this.event.end_condition || !this.event.end_condition.stopper)) {
      this.nextEvent();
    }
  }

  setEventEndCondition() {
    // set end condition listeners
    this.removeAllListeners();

    if (this.event.end_condition) {
      switch (this.event.end_condition.type) {
        case 'seeker_on_position':
          this.levelRef.seeker.onPosition.addOnce(this.handleEndConditionPosition, this);
          break;

        case 'user_found_any_character':
          this.levelRef.location.onFindChar.addOnce(this.handleEndConditionFoundAny, this);
          break;

        case 'camera_on_position':
          this.levelRef.camera.onPosition.add(this.handleEndConditionCamera, this);
          break;

        case 'user_tap_goto_marker':
          break;

        case 'user_drag_character':
          this.levelRef.onDragCharacter.add(this.handleEndConditionDrag, this);
          break;

        case 'user_hide_character':
          this.levelRef.onHideCharacter.add(this.handleEndConditionHide, this);
          break;

        case 'user_scroll_screen':
          this.levelRef.camera.onScroll.add(this.handleEndConditionScroll, this);
          break;

        case 'is_character_hidden':
          this.checkIfCharacterIsHidden(this.event.end_condition.character);
          break;

        case 'user_tap_clothing_edit': {
          const target = this.event.end_condition.character;
          const slot = this.levelRef.location.findSlotWithCharacter(target);
          slot.character.onTapClothingEdit.addOnce(this.handleEndCondition, this);
          break;
        }

        case 'user_tap_clothing_check': {
          const target = this.event.end_condition.character;
          const slot = this.levelRef.location.findSlotWithCharacter(target);
          slot.character.onTapClothingCheck.addOnce(this.handleEndCondition, this);
          break;
        }

        case 'user_wear_clothes': {
          const target = this.event.end_condition.character;
          const slot = this.levelRef.location.findSlotWithCharacter(target);
          slot.character.onWearClothes.addOnce(this.handleEndCondition, this);
          break;
        }

        case 'user_tap_check_mark': {
          this.levelRef.gameHud.charactersList.btnCheck.onInputDown.addOnce(
            this.handleEndCondition,
            this
          );
          break;
        }
      }
    }
  }
  /* eslint-enable */

  handleEndConditionPosition() {
    this.levelRef.location.removeGotoMarker();
    this.handleEndCondition();
  }

  handleEndConditionFoundAny() {
    this.handleEndCondition();
  }

  handleGotoMarkerTap() {
    this.handleEndCondition();
  }

  handleEndConditionCamera() {
    this.levelRef.camera.onPosition.remove(this.handleEndConditionCamera, this);
    this.handleEndCondition();
  }

  handleEndConditionDrag() {
    this.levelRef.onDragCharacter.remove(this.handleEndConditionDrag, this);
    this.handleEndCondition();
  }

  handleEndConditionHide() {
    this.levelRef.onHideCharacter.remove(this.handleEndConditionHide, this);
    this.handleEndCondition();
  }

  handleEndConditionScroll() {
    this.levelRef.camera.onScroll.remove(this.handleEndConditionScroll, this);
    this.handleEndCondition();
  }

  checkIfCharacterIsHidden(characterId) {
    if (this.levelRef.location.findSlotWithCharacter(characterId)) {
      this.handleEndCondition();
    } else {
      this.game.time.events.add(100, this.checkIfCharacterIsHidden, this, characterId);
    }
  }

  removeAllListeners() {
    if (this.levelRef.camera)
      this.levelRef.camera.onPosition.remove(this.handleEndConditionCamera, this);
    if (this.levelRef.onDragCharacter)
      this.levelRef.onDragCharacter.remove(this.handleEndConditionDrag, this);
    if (this.levelRef.onHideCharacter)
      this.levelRef.onHideCharacter.remove(this.handleEndConditionHide, this);
    if (this.levelRef.camera)
      this.levelRef.camera.onScroll.remove(this.handleEndConditionScroll, this);
    if (this.levelRef.gameHud.charactersList.btnCheck) {
      this.levelRef.gameHud.charactersList.btnCheck.onInputDown.remove(
        this.handleEndCondition,
        this
      );
    }
  }

  handleEndCondition() {
    // set next event id to exit the looped events
    if (this.event.end_condition && this.event.end_condition.next_event_id !== undefined) {
      for (let i = 0; i < this.data.events.length; i++) {
        if (this.data.events[i].id === this.event.end_condition.next_event_id) {
          this.ind = i - 1;
          break;
        }
      }
    }

    // remove delay timer
    if (this.delayEvent) {
      this.game.time.events.remove(this.delayEvent);
      this.delayEvent = null;
    }

    // process next event
    this.nextEvent();
  }

  step(dt) {
    if (!this.isDelayed && !this.skip) {
      this.time += dt;
      if (this.time >= this.waitTime) {
        if (!this.event.end_condition || !this.event.end_condition.stopper) {
          this.nextEvent();
        }
      }
    }
  }

  destroy() {
    if (this.playingVO) {
      this.playingVO.stop();
    }
  }
}
